/** @format */

import React from 'react';

/**
 * A Higher Order Component for handling changes to lists
 */
function handleListChanges(listKey, ListComponentContainer) {
    if (typeof listKey !== 'string') {
        throw 'I need a listKey in the handleListChanges function';
    }

    class ListChangeHandler extends React.Component {
        constructor(props) {
            super(props);
            this.handleRemove = this.handleRemove.bind(this);
            this.handleChange = this.handleChange.bind(this);
            this.handleAdd = this.handleAdd.bind(this);
        }

        handleRemove(id) {
            const index = this.props[listKey].findIndex(item => item.id === id);
            this.change({$splice: [[index, 1]]});
        }

        handleChange(id, value) {
            const index = this.props[listKey].findIndex(item => item.id === id);
            this.change({$splice: [[index, 1, value]]});
        }

        handleAdd() {
            this.change({$push: [{}]});
        }

        change(value) {
            const state = {};
            state[listKey] = value;
            this.props.onChange(state);
        }

        render() {
            const props = {...this.props};
            props.onAdd = this.handleAdd.bind(this);
            props.onChange = this.handleChange.bind(this);
            props.onRemove = this.handleRemove.bind(this);
            props[listKey] = [...this.props[listKey]];
            return <ListComponentContainer {...props} />;
        }
    }

    return ListChangeHandler;
}

export default handleListChanges;
